import { Button } from '@buffer-mono/popcorn'

import { channelSettings } from '~publish/legacy/routes'

import { usePostData } from './PostCardContext'
import { PostCardNotice } from './PostCardNotice'

import type { JSX } from 'react'

export const PostCardPausedQueueNotice = (): JSX.Element | null => {
  const { channel, status } = usePostData()

  if (!channel.isQueuePaused || status === 'sent') {
    return null
  }

  return (
    <PostCardNotice variant="warning">
      This post&apos;s channel queue is paused. Adjust the channel settings to
      resume.
      <PostCardNotice.Action>
        <Button
          variant="warning"
          size="small"
          as="a"
          href={channelSettings.getRoute({
            channelId: channel.id,
            tab: 'general',
          })}
          rel="noopener noreferrer"
          target="_blank"
        >
          Resume Queue
        </Button>
      </PostCardNotice.Action>
    </PostCardNotice>
  )
}

PostCardPausedQueueNotice.displayName = 'PostCardPausedQueueNotice'
